import { KeyboardArrowLeft, MoreHoriz, Telegram } from "@mui/icons-material";
import {
  AppBar,
  Autocomplete,
  Avatar,
  Dialog,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ChatBox from "./UI/ChatBox";

import {
  EmployeeTrainingData,
  Message,
  Widget,
  baseURL,
} from "../utils/helper";
interface Props {
  open: boolean;
  onClosingModal: () => void;
  onClickingOthers: () => void;
}

function ChatbotModal(props: Props) {
  const { open, onClosingModal, onClickingOthers } = props;
  const { emp_name = "Random User", emp_id } =
    JSON.parse(localStorage.getItem("user") as any) || {};
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [dropDownData, setDropDownData] = useState<String[]>([]);
  const [questionData, setQuestionData] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState("");
  const openMenu = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (inputValue && inputValue.length > 1) {
      setOpenAutoComplete(true);
    } else {
      setOpenAutoComplete(false);
    }
  }, [inputValue]);

  const [openAutoComplete, setOpenAutoComplete] = useState(false);
  async function getQuestionJSON(menu: string) {
    try {
      let getQuestionRequest = await fetch(
        `${baseURL}/fun/getQuestions?fileName=${menu}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      );
      let getQuestionResponse = await getQuestionRequest.json();
      const questionsArray = getQuestionResponse?.map(
        (data: any) => data?.question
      );
      setQuestionData(getQuestionResponse);
      setDropDownData(questionsArray);
      const message: Message = {
        type: "bot",
        message: `What do you want to know about ${menu}?Start typing to get suggestions...`,
      };
      SetMessage((oldMessage) => [...oldMessage, message]);
    } catch (error) {
      console.log("error in getting questions");
    }
  }
  const homeButton: Widget[] = [
    {
      id: "home",
      name: "Home",
      onClick: () => {
        home();
      },
    },
  ];
  function showDetailedLearning(getLearningResponse: EmployeeTrainingData) {
    if (getLearningResponse) {
      const message: Message = {
        type: "bot",
        message: (
          <>
            <Typography variant="body1">
              Please find the detailed training below
            </Typography>
            <br></br>
            <Typography variant="body2">
              Total Training -{" "}
              <b>{getLearningResponse?.total_training_hrs}hrs</b>
            </Typography>
            <Typography variant="body2">
              OJT Traning - <b>{getLearningResponse?.ojt}hrs</b>
            </Typography>
            <Typography variant="body2">
              Classroom Traning - <b>{getLearningResponse?.classroom}hrs</b>
            </Typography>
            <Typography variant="body2">
              Behavioural Traning - <b>{getLearningResponse?.behavioural}hrs</b>
            </Typography>
            <Typography variant="body2">
              Linkedin Traning - <b>{getLearningResponse?.linkedin}hrs</b>
            </Typography>
            <Typography variant="body2">
              Mandatory Traning -{" "}
              <b>{getLearningResponse?.mandatory_training}hrs</b>
            </Typography>
            <Typography variant="body2">
              Hr Induction - <b>{getLearningResponse?.hr_induction}hrs</b>
            </Typography>
            <Typography variant="body2">
              Total Manday -{" "}
              <b>{getLearningResponse?.total_manday_training}days</b>
            </Typography>
          </>
        ),
        buttons: homeButton,
      };
      SetMessage((oldMessage) => [...oldMessage, message]);
    }
  }
  async function getLearning() {
    try {
      let getLearningRequest = await fetch(
        `${baseURL}/fun/getLearning?empCode=${emp_id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      );
      let getLearningResponse: EmployeeTrainingData =
        await getLearningRequest.json();
      const message: Message = {
        type: "bot",
        message: (
          <>
            <Typography variant="body2">
              {`Hi ${emp_name}, You have completed`}
              <b>&nbsp;{getLearningResponse?.total_manday_training}</b>
              {` Man Days of Training`}
            </Typography>

            <Typography
              variant="body2"
              style={{
                cursor: "pointer",
                marginTop: 5,
                color: "#1A202C",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
              onClick={() => {
                showDetailedLearning(getLearningResponse);
              }}
            >
              Please click for more detailed information....
            </Typography>
          </>
        ),
      };
      SetMessage((oldMessage) => [...oldMessage, message]);
      console.log("getLearningRequest", getLearningResponse);
    } catch (error) {
      console.log("Error in getting learning", error);
    }
  }
  async function openPolicy(policyName: string) {
    const openPolicyRequest = await fetch(
      `${baseURL}/fun/getPolicyDocuments?policyName=${encodeURIComponent(
        policyName
      )}`
    );
    const openPolicyResponse = await openPolicyRequest.json();
    console.log("openPolicyResponse", openPolicyResponse);
    let pdfBase64 = Object.values(openPolicyResponse)[0];
    let newWindow = window.open();
    newWindow?.document.write(
      `<object data=${pdfBase64} type="application/pdf" width="100%" height="100%"></object>`
    );
  }
  async function getPolicies() {
    const getPolicyRequest = await fetch(`${baseURL}/fun/getPolicies`);
    const parsedResponse = await getPolicyRequest.json();
    let widget: Widget[] = [];
    if (parsedResponse.length > 0 && Array.isArray(parsedResponse)) {
      parsedResponse?.map((item: string, index) => {
        console.log("item length", item);
        widget.push({
          id: item,
          name: item,
          type: "policy",
          onClick: () => {
            openPolicy(`${item}`);
          },
        });
      });
      const message: Message[] = [
        {
          type: "bot",
          message: "Please select the policy to open",
          buttons: widget,
        },
      ];
      SetMessage((oldMessage) => [...oldMessage, ...message]);
    }
    console.log("parsed policy", parsedResponse);
  }
  const initialMenu: Widget[] = [
    {
      id: "Benefits",
      name: "Benefits",
      onClick: () => {
        getQuestionJSON("benefits");
      },
    },
    {
      id: "Leave",
      name: "Leave",
      onClick: () => {
        getQuestionJSON("leave");
      },
    },
    {
      id: "Offboarding",
      name: "Offboarding",
      onClick: () => {
        getQuestionJSON("offboarding");
      },
    },
    {
      id: "Onboarding",
      name: "Onboarding",
      onClick: () => {
        getQuestionJSON("onboarding");
      },
    },
    {
      id: "Insurances",
      name: "Insurances",
      onClick: () => {
        getQuestionJSON("insurance");
      },
    },
    {
      id: "Service Request",
      name: "SR",
      onClick: () => {
        getQuestionJSON("ServiceRequest");
      },
    },
    {
      id: "My Leave",
      name: "My Leave",
      onClick: () => {
        getLeave();
      },
      disable: emp_name === "Random User" ? true : false,
    },
    {
      id: "My Learning",
      name: "My Learning",
      onClick: () => {
        getLearning();
      },
      disable: emp_name === "Random User" ? true : false,
    },
    {
      id: "Payroll",
      name: "Payroll",
      onClick: () => {
        getQuestionJSON("payroll");
      },
    },
    {
      id: "View Policy",
      name: "Policy",
      onClick: () => {
        getPolicies();
      },
    },
    {
      id: "Others",
      name: "Others",
      onClick: () => {
        onClickingOthers();
      },
      disable: emp_name === "Random User" ? true : false,
    },
  ];
  const initialMessage: Message[] = [
    {
      type: "bot",
      message: `Hello ${emp_name}, kindly choose from the below option`,
      buttons: initialMenu,
    },
  ];
  const [message, SetMessage] = useState<Message[]>(initialMessage);
  const divRef: any = useRef(null);
  const scrollToBottom = () => {
    if (divRef.current) {
      divRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  };
  useEffect(() => {
    if (message) {
      console.log("message changed+++++");
      scrollToBottom();
    }
  }, [message]);
  function home() {
    SetMessage((oldMessage) => [...oldMessage, ...initialMessage]);
  }
  function sendQuery(event: any, value: any) {
    event.preventDefault();
    console.log("question data", questionData, "value++", value);
    if (value) {
      const botResponse = questionData?.find(
        (data) => data?.question.trim() === value?.trim()
      );
      const response = botResponse?.text;
      const message: Message[] = [
        { type: "user", message: value },
        { type: "bot", message: response, buttons: homeButton },
      ];
      SetMessage((oldMessage) => [...oldMessage, ...message]);
      setOpenAutoComplete(false);
      setInputValue("");
    }
  }
  async function getLeave() {
    try {
      let getLeaveRequest = await fetch(
        `${baseURL}/getLeaveBalance?empcode=${emp_id}`
      );
      let getLeaveResponse = await getLeaveRequest.text();
      const message: Message[] = [{ type: "bot", message: getLeaveResponse }];
      SetMessage((oldMessage) => [...oldMessage, ...message]);
    } catch (error) {
      console.log("error in get leave", error);
    }
  }
  return (
    <>
      <Dialog
        open={open}
        onClose={onClosingModal}
        maxWidth="xs"
        fullWidth={true}
        PaperProps={{
          sx: {
            height: "500px",
            maxHeight: "500px",
            position: "absolute",
            right: 80,
            bottom: 10,
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <AppBar
          position="static"
          id="message_header"
          style={{ backgroundColor: "#1A202C", height: "15%" }}
        >
          <Toolbar>
            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={onClosingModal}
              >
                <KeyboardArrowLeft />
              </IconButton>
              <Avatar
                style={{ height: "30px", width: "30px" }}
                alt="Remy Sharp"
                src="/RIVA_new.png"
              />
              <Typography>RIVA</Typography>
            </div>
          </Toolbar>
        </AppBar>
        <div
          id="message_area"
          style={{ marginTop: 10, height: "70%", overflowY: "scroll" }}
        >
          {message.map((item, index) => (
            <ChatBox
              key={`${item.message}-${index}`}
              type={item?.type}
              message={item?.message}
              buttons={item?.buttons}
            />
          ))}
          <div ref={divRef}></div>
        </div>
        <div
          id="message_footer"
          style={{
            display: "flex",
            alignItems: "center",
            height: "15%",
            backgroundColor: "white",
            padding: 10,
            justifyContent: "center",
          }}
        >
          <Autocomplete
            inputValue={inputValue}
            onInputChange={(e, value) => {
              setInputValue(value);
            }}
            value={inputValue}
            disablePortal
            freeSolo
            onChange={sendQuery}
            id="combo-box-demo"
            disabled={dropDownData.length <= 0}
            options={dropDownData}
            sx={{ width: 300 }}
            renderInput={(params: any) => (
              <TextField {...params} label="Enter your query" />
            )}
            open={openAutoComplete}
            blurOnSelect={true}
          />
          <IconButton
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <MoreHoriz />
          </IconButton>
          {/* <IconButton>
            <Telegram />
          </IconButton> */}
        </div>
      </Dialog>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem disabled onClick={handleClose}>
          Rate Conversation
        </MenuItem>
        {/* <MenuItem onClick={handleClose}>Change Profile</MenuItem> */}
      </Menu>
    </>
  );
}

export default ChatbotModal;
